import styled from '@emotion/styled';
import StoreSelect from './StoreSelect';
import LabelSelect from './LabelSelect';
import KeyWordSelect from './KeyWordSelect';
import { useContext } from 'react';
import { ConfigContext } from './context';

/**
 * @description 商品选择器筛选条件
 */
function FilterBar() {
  const { inSupplementKnowledge = false } = useContext(ConfigContext);
  return (
    <FilterBarContent>
      <StoreSelect />
      {!inSupplementKnowledge && <LabelSelect />}
      <KeyWordSelect />
    </FilterBarContent>
  );
}

const FilterBarContent = styled.div`
  height: 52px;
  padding: 10px 16px;
  align-items: center;
  display: flex;
  border-bottom: 1px solid var(--fett-border-default);
  flex-shrink: 0;
  gap: 16px;
`;

export default FilterBar;
